const travellerDetailsTabs = [
  {
    label: "1. Review & Travellers",
    value: "Review & Travellers",
  },
  // {
  //   label: "2. Payment",
  //   value: "Payment",
  // },
];

export { travellerDetailsTabs };
